"use strict";

var _taggedTemplateLiteral = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js").default;
var _templateObject;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var d3_1 = require("d3");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var modules_1 = require("./modules");
var AtomDualAxisBarChart_1 = __importDefault(require("./modules/BarChart/AtomDualAxisBarChart"));
var App = function App() {
  return react_1.default.createElement(Container, null, react_1.default.createElement("h1", null, "Live Development Space"), react_1.default.createElement(modules_1.AtomDonut, {
    symbol: 'ellie',
    data: [{
      label: 'a',
      value: 9000
    }, {
      label: 'b',
      value: 1.12
    }, {
      label: 'a',
      value: 8600
    }, {
      label: 'b',
      value: 1.56
    }, {
      label: 'a',
      value: 8600
    }, {
      label: 'b',
      value: 1.0
    }, {
      label: 'a',
      value: 8600
    }, {
      label: 'b',
      value: 0.89
    }]
  }), react_1.default.createElement(AtomDualAxisBarChart_1.default, {
    data: [{
      group: 'one',
      label: 'a',
      value: 9000,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-blue)'
    }, {
      group: 'one',
      label: 'b',
      value: 1.12,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-purple)'
    }, {
      group: 'two',
      label: 'a',
      value: 8600,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-blue)'
    }, {
      group: 'two',
      label: 'b',
      value: 1.56,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-purple)'
    }, {
      group: 'three',
      label: 'a',
      value: 8600,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-blue)'
    }, {
      group: 'three',
      label: 'b',
      value: 1.0,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-purple)'
    }, {
      group: 'four',
      label: 'a',
      value: 8600,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-blue)'
    }, {
      group: 'four',
      label: 'b',
      value: -0.89,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-purple)'
    }],
    y1Label: 'a',
    y2Label: 'b',
    axisColor: '#c4c4c4'
  }), react_1.default.createElement(AtomDualAxisBarChart_1.default, {
    data: [{
      group: 'one',
      label: 'a',
      value: 9000,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-blue)'
    }, {
      group: 'one',
      label: 'b',
      value: -1.12,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-purple)'
    }, {
      group: 'two',
      label: 'a',
      value: 8600,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-blue)'
    }, {
      group: 'two',
      label: 'b',
      value: -1.56,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-purple)'
    }, {
      group: 'three',
      label: 'a',
      value: 8600,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-blue)'
    }, {
      group: 'three',
      label: 'b',
      value: -1.0,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-purple)'
    }, {
      group: 'four',
      label: 'a',
      value: 8600,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-blue)'
    }, {
      group: 'four',
      label: 'b',
      value: -0.89,
      format: (0, d3_1.format)('$.2'),
      color: 'var(--atom-dark-purple)'
    }],
    y1Label: 'a',
    y2Label: 'b',
    axisColor: '#c4c4c4'
  }));
};
exports.default = App;
var Container = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 20px auto;\n  width: 50%;\n  max-height: 500px;\n  @media (max-width: 1100px) {\n    margin: 20px auto;\n    width: 100%;\n  } ;\n"])));